import React from 'react';

interface LogoProps {
  className?: string;
  color?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '', color = '#93cbb6' }) => {
  return (
    <svg 
      className={className}
      width="170" 
      height="60" 
      viewBox="0 0 170 60" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* SeaDent text */}
      <text 
        x="10" 
        y="37" 
        fontFamily="'Great Vibes', cursive" 
        fontSize="40" 
        fill={color}
        style={{ textShadow: '0 1px 2px rgba(0, 0, 0, 0.2)' }}
      >
        SeaDent
      </text>
    </svg>
  );
};

export default Logo; 